import React from 'react';
import { Mail, MapPin, Clock } from 'lucide-react';

const VENUE_ADDRESS = {
  line1: 'Motion Reality Sim Racing Ltd',
  line2: '"Win a Sim Rig" Free Entry Draw',
  line3: 'Unit 9, Croft Business Park, Carrock Road',
  line4: 'Bromborough, Wirral',
  postcode: 'CH62 3RA',
};

// UK Gambling Act 2005 compliance: the paid £5 sim rig draw must offer an
// accessible free entry route on equal terms. This card explains how to enter
// by post without paying — no purchase necessary.
export default function PostalEntryInfo() {
  return (
    <div className="border border-green-500/30 bg-green-500/[0.03] p-6">
      <div className="flex items-center gap-2 mb-3">
        <Mail className="w-4 h-4 text-green-400" />
        <p className="text-green-400 text-[10px] font-bold tracking-widest">FREE POSTAL ENTRY · NO PURCHASE NECESSARY</p>
      </div>
      <h3 className="text-white font-black text-lg uppercase mb-2">Enter for free by post</h3>
      <p className="text-white/50 text-xs leading-relaxed mb-4">
        You don't have to pay to enter the sim rig draw. Postal entries are treated on <span className="text-white font-bold">exactly the same terms</span> as
        paid £5 entries and go into the same random draw.
      </p>

      <p className="text-white/40 text-[10px] font-bold tracking-widest mb-1.5">WHAT TO INCLUDE</p>
      <ul className="text-white/50 text-xs space-y-1 mb-4 leading-relaxed">
        <li>• Your full name</li>
        <li>• Your full postal address</li>
        <li>• Your email address (so we can contact you if you win)</li>
        <li>• Your date of birth (proof you're 18+)</li>
        <li>• A signed statement that you accept the competition <span className="text-white">terms</span></li>
      </ul>

      <p className="text-white/40 text-[10px] font-bold tracking-widest mb-1.5">SEND ENTRIES TO</p>
      <div className="flex items-start gap-2 text-white/70 text-xs leading-relaxed mb-4">
        <MapPin className="w-4 h-4 text-green-400 mt-0.5 shrink-0" />
        <div>
          <p className="font-bold text-white">{VENUE_ADDRESS.line1}</p>
          <p>{VENUE_ADDRESS.line2}</p>
          <p>{VENUE_ADDRESS.line3}</p>
          <p>{VENUE_ADDRESS.line4}</p>
          <p>{VENUE_ADDRESS.postcode}</p>
        </div>
      </div>

      <div className="flex items-start gap-2 text-white/40 text-[11px] leading-relaxed border-t border-white/5 pt-3">
        <Clock className="w-3.5 h-3.5 text-white/30 mt-0.5 shrink-0" />
        <p>
          One entry per stamped envelope. Entries must arrive before the closing date — <span className="text-white/60">30 June</span> for the
          January–June draw and <span className="text-white/60">31 December</span> for the July–December draw. Envelopes received after the closing
          date are entered into the next draw.
        </p>
      </div>
    </div>
  );
}